// extracted by mini-css-extract-plugin
module.exports = {"channel":"styles__channel___1ARHM","name":"styles__name___1fXbH","button":"styles__button___2C82T"};